import type { CallTreatment } from '@personical/cc-shared-types';

interface Props {
  treatment: CallTreatment | undefined;
  size?: 'sm' | 'md';
}

const STYLE: Record<Exclude<CallTreatment, 'normal'>, { label: string; cls: string }> = {
  vip: {
    label: 'VIP',
    cls: 'bg-amber-100 text-amber-800 ring-amber-200'
  },
  screen: {
    label: 'Screen',
    cls: 'bg-yellow-100 text-yellow-800 ring-yellow-200'
  },
  block: {
    label: 'Block',
    cls: 'bg-red-100 text-red-800 ring-red-200'
  }
};

export function CallTreatmentBadge({ treatment, size = 'sm' }: Props) {
  if (!treatment || treatment === 'normal') return null;
  const config = STYLE[treatment];
  if (!config) return null;
  const sizeCls = size === 'sm' ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2 py-0.5';
  return (
    <span
      className={`inline-flex items-center rounded-full ring-1 font-medium uppercase tracking-wider ${sizeCls} ${config.cls}`}
    >
      {config.label}
    </span>
  );
}
